/** Admin-owned display grouping. Members retain their original product pricing and options. */
export interface BentoFamilyMemberV1{
  readonly productId:string;
  readonly label:string;
}
export interface BentoFamilyViewV1{
  readonly familyId:string;
  readonly name:string;
  readonly categoryId:string;
  readonly active:boolean;
  readonly position:number;
  readonly members:readonly BentoFamilyMemberV1[];
  readonly defaultProductId?:string;
}
export interface BentoFamilyReferencesV1{
  readonly productIds:ReadonlySet<string>;
  readonly categoryIds:ReadonlySet<string>;
}
const record=(value:unknown):Record<string,unknown>=>value&&typeof value==='object'&&!Array.isArray(value)?value as Record<string,unknown>:{};
const text=(value:unknown):value is string=>typeof value==='string'&&value.trim().length>0;
export function validateBentoFamilyViewsV1(value:unknown,refs:BentoFamilyReferencesV1):readonly string[]{
  if(value===undefined)return[];
  if(!Array.isArray(value))return['商品 family 設定必須是列表'];
  const errors:string[]=[],familyIds=new Set<string>(),assigned=new Set<string>();
  for(const raw of value){
    const family=record(raw),label=text(family.familyId)?family.familyId:'未填編號';
    if(!text(family.familyId)||familyIds.has(family.familyId))errors.push('商品 family '+label+' 編號缺少或重複');
    if(text(family.familyId))familyIds.add(family.familyId);
    if(!text(family.name))errors.push('商品 family '+label+' 未填顯示名稱');
    if(!text(family.categoryId)||!refs.categoryIds.has(family.categoryId))errors.push('商品 family '+label+' 分類不存在');
    if(typeof family.active!=='boolean')errors.push('商品 family '+label+' 啟用格式錯誤');
    if(!Number.isSafeInteger(family.position)||Number(family.position)<0)errors.push('商品 family '+label+' 排序格式錯誤');
    const memberIds=new Set<string>();
    if(!Array.isArray(family.members)||!family.members.length)errors.push('商品 family '+label+' 至少需要一個商品');
    for(const rawMember of Array.isArray(family.members)?family.members:[]){
      const member=record(rawMember);
      if(!text(member.productId)||!refs.productIds.has(member.productId))errors.push('商品 family '+label+' 商品不存在');
      if(text(member.productId)){
        if(memberIds.has(member.productId)||assigned.has(member.productId))errors.push('商品 family '+label+' 商品重複分組');
        memberIds.add(member.productId);assigned.add(member.productId);
      }
      if(!text(member.label))errors.push('商品 family '+label+' 未填成員顯示名稱');
    }
    if(family.defaultProductId!==undefined&&(!text(family.defaultProductId)||!memberIds.has(family.defaultProductId)))errors.push('商品 family '+label+' 預設商品不屬於成員');
  }
  return errors;
}
/** Fail closed on malformed references; never infer a family from names, category names or IDs. */
export function projectBentoFamilyViewsV1(value:unknown,refs:BentoFamilyReferencesV1):readonly BentoFamilyViewV1[]{
  if(value===undefined||validateBentoFamilyViewsV1(value,refs).length)return Object.freeze([]);
  return Object.freeze((value as readonly BentoFamilyViewV1[]).filter(family=>family.active).map(family=>Object.freeze({
    familyId:family.familyId,name:family.name,categoryId:family.categoryId,active:family.active,position:family.position,
    members:Object.freeze(family.members.map(member=>Object.freeze({productId:member.productId,label:member.label}))),
    ...(family.defaultProductId!==undefined?{defaultProductId:family.defaultProductId}:{}),
  })).sort((a,b)=>a.position-b.position||a.familyId.localeCompare(b.familyId)));
}
